<template>
    <ModalContainer :visible="visible" :show-footer="false" :loading="loading">
        <template v-slot:header>
            <button type="button" class="close"  @click="$emit('close-purchase-subscription-modal')"><i class="las la-times"></i></button>
            <h4 class="modal-title">{{ $t('common.buy_subscription') }}</h4>
        </template>
        <template v-slot:body>
            <div v-if="subscriptionsTypeSeparator.length > 0">
                <div class="panel panel-default" v-show="step < 4">
                    <div class="panel-body" style="padding:20px;">
                        <h1 class="h2 margin-bottom-20">1. {{$t('components.purchase_subscription_modal.step1')}}</h1>
                        <div class="form-horizontal">
                            <div class="form-group">
                                <label for="client_subscription_email" class="col-xs-12 col-md-4 control-label">{{$t('components.purchase_subscription_modal.which_subscription')}}</label>
                                <div class="col-xs-12 col-md-8">
                                    <select class="form-control" :disabled="creditCardCheckout" id="subscription-type-options" name="subscription-type-options" v-model="newSubscription.subscription_type">
                                        <option v-for="(subscriptionType, index) in subscriptionsTypeSeparator"  :disabled="subscriptionType.separator" v-bind:key="index" :value="subscriptionType">
                                            <div v-if="!subscriptionType.separator">
                                                {{subscriptionType.name}}
                                            </div>
                                            <div v-else>
                                                {{subscriptionType.separator_name}}
                                            </div>
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group" v-show="isSelectedNormal">
                                <label for="date_new_subscription" class="col-xs-12 col-md-4 control-label">{{$t('components.purchase_subscription_modal.from')}}</label>
                                <div class="col-xs-12 col-md-8 has-feedback">
                                    <Datetime id="date_new_subscription"
                                              type="date"
                                              :value-zone="TIMEZONE_DEFAULT"
                                              :zone="TIMEZONE_DEFAULT"
                                              :disabled="creditCardCheckout"
                                              v-model="newSubscription.start_date"
                                              :phrases="{ok: $t('common.time.choose_datetime'), cancel: $t('common.time.cancel_datetime')}"
                                              input-class="form-control"></Datetime>
                                    <span class="glyphicon glyphicon-calendar form-control-feedback" aria-hidden="true"></span>
                                </div>
                            </div>
                            <div class="form-group" v-if="step !== 3">
                                <div class="col-xs-12 col-md-4 control-label"></div>
                                <div class="col-xs-12 col-md-8">
                                    <PriceTable v-if="newSubscription.subscription_type.price && newSubscription.subscription_type.price_currency" :price="newSubscription.subscription_type.price" :currency="newSubscription.subscription_type.price_currency"></PriceTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel panel-default" v-show="step < 4">
                    <div class="panel-body" style="padding:20px;">
                        <h1 class="h2 margin-bottom-20">2. {{$t('components.purchase_subscription_modal.step2')}}</h1>
                        <div class="form-horizontal">
                            <div
                                    v-show="errorMessage"
                                    class="alert alert-danger"
                                    style="margin:10px;"
                                    role="alert"
                            >
                                {{ errorMessage }}
                            </div>
                            <div class="form-group">
                                <label for="client_subscription_email" class="col-xs-12 col-md-4 control-label">{{ $t('common.email') }}</label>
                                <div class="col-xs-12 col-md-8">
                                    <input class="form-control" type="text" :disabled="clientExist || creditCardCheckout" id="client_subscription_email" v-model="newSubscription.clientDetail.email" placeholder="">
                                </div>
                            </div>
                            <div v-if="clientChecked" class="form-group">
                                <label for="client_subscription_firstname" class="col-xs-12 col-md-4 control-label">{{ $t('common.first_name') }}</label>
                                <div class="col-xs-12 col-md-8">
                                    <input class="form-control" type="text" :disabled="clientExist || creditCardCheckout" id="client_subscription_firstname" v-model="newSubscription.clientDetail.first_name" placeholder="">
                                </div>
                            </div>
                            <div v-if="clientChecked" class="form-group">
                                <label for="client_subscription_lastname" class="col-xs-12 col-md-4 control-label">{{ $t('common.last_name') }}</label>
                                <div class="col-xs-12 col-md-8">
                                    <input class="form-control" type="text" :disabled="clientExist || creditCardCheckout" id="client_subscription_lastname" v-model="newSubscription.clientDetail.last_name" placeholder="">
                                </div>
                            </div>

                            <div v-if="clientChecked" class="form-group">
                                <label for="client_subscription_phone" class="col-xs-12 col-md-4 control-label">{{ $t('common.phone') }}</label>
                                <div class="col-xs-12 col-md-8">
                                    <VuePhoneNumberInput
                                            :disabled="clientExist || creditCardCheckout"
                                            @update="updatePhoneNumber"
                                            no-validator-state
                                            :default-country-code="country_phone"
                                            v-model="newSubscription.clientDetail.phone_number"
                                            :translations="translations"
                                            id="client_subscription_phone"></VuePhoneNumberInput>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="panel-footer" v-if="!clientChecked">
                        <a class="btn btn-primary btn-block btn-lg" @click="checkClientExist">
                            {{ $t('common.next') }} <i class="las la-angle-right"></i>
                        </a>
                    </div>
                </div>
                <div class="panel panel-default" v-show="step === 3">
                    <div class="panel-body" style="padding:20px;">
                        <h1 class="h2 margin-bottom-20">3. {{$t('components.purchase_subscription_modal.step3')}}</h1>
                        <p class="margin-bottom-20">{{$t('components.purchase_subscription_modal.select_pm')}}</p>
                        <div
                                v-show="creditCardErrorMessage"
                                class="alert alert-danger"
                                style="margin:10px;"
                                role="alert"
                        >
                            {{ creditCardErrorMessage }}
                        </div>
                        <div  class="form-horizontal">
                            <div class="form-group">
                                <label for="payment-method-options" class="col-xs-12 col-md-4 control-label">{{ $t('common.payment_method')}}</label>
                                <div class="col-xs-12 col-md-8">
                                    <select class="form-control" id="payment-method-options" :disabled="creditCardCheckout"  v-model="newSubscription.payment_mode">
                                        <option :value="creditCardPaymentMode">{{creditCardPaymentModeName}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-xs-12 col-md-4 control-label"></div>
                                <div class="col-xs-12 col-md-8">
                                    <PriceTable v-if="newSubscription.subscription_type.price && newSubscription.subscription_type.price_currency" :price="newSubscription.subscription_type.price" :currency="newSubscription.subscription_type.price_currency"></PriceTable>
                                </div>
                            </div>
                            <div class="form-group" v-if="newSubscription.payment_mode === creditCardPaymentMode && creditCardCheckout">
                                <label for="client_subscription_phone_payment" class="col-xs-12 col-md-4 control-label">{{ $t('common.credit_card') }}</label>
                                <div class="col-xs-12 col-md-8">
                                    <StripeElements  ref="elementsRef"
                                                     id="client_subscription_phone_payment"
                                                     :pk=STRIPE_PUBLIC_KEY
                                                     :locale="$i18n.locale"
                                                     @token="tokenCreated"></StripeElements>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-4"></div>
                                <div class="col-xs-12 col-md-8">
                                    <ConversionNote  v-if="creditCardCheckout && newSubscription.subscription_type.price && newSubscription.subscription_type.price_currency" :price="newSubscription.subscription_type.price" :currency="newSubscription.subscription_type.price_currency"></ConversionNote>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="panel-footer">
                        <a v-if="creditCardCheckout" class="btn btn-primary btn-block btn-lg" href="" @click.prevent.stop="confirmPayClick">
                            {{ $t('common.pay_and_confirm') }} <i class="las la-angle-right"></i>
                        </a>
                        <a v-else class="btn btn-primary btn-block btn-lg" href="" @click.prevent.stop="confirmCreditCardMethod">
                            {{ $t('common.next') }} <i class="las la-angle-right"></i>
                        </a>
                    </div>
                </div>
                <div class="panel panel-default margin-0" v-show="step >= 4">
                    <div class="panel-body" style="padding:20px;">
                        <h1 class="h2 margin-bottom-20">4. {{$t('components.purchase_subscription_modal.step4')}}</h1>
                        <p class="margin-0 text-center" style="font-size:80px;color:#3c763d;">
                            <i class="las la-check-circle"></i>
                        </p>
                        <div class="alert alert-success margin-0" role="alert">
                            <p><b>{{$t('components.purchase_subscription_modal.success1')}}</b> {{$t('components.purchase_subscription_modal.success2')}}</p>
                            <p>{{$t('components.purchase_subscription_modal.success3')}}</p>
                        </div>
                    </div>
                    <div class="panel-footer">
                        <a class="btn btn-primary btn-block btn-lg" href="" @click.prevent.stop="$emit('close-purchase-subscription-modal')">
                            {{ $t('common.close') }} <i class="las la-angle-right"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div v-else>
                <div
                        class="alert alert-danger"
                        role="alert"
                >
                    {{$t('components.purchase_subscription_modal.no_subscriptions')}}
                </div>
                <a class="btn btn-primary btn-block btn-lg" href="" @click.prevent.stop="$emit('close-purchase-subscription-modal')">
                    {{ $t('common.close') }}
                </a>
            </div>
        </template>
    </ModalContainer>
</template>

<script>
    import parsePhoneNumber from 'libphonenumber-js'
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'
    import {Datetime} from "vue-datetime";
    import 'vue-datetime/dist/vue-datetime.css'
    import { StripeElements } from 'vue-stripe-checkout';
    import {Utils, moveUpDatetimePopup} from "../../common/utils";
    import i18n from '../../i18n'
    import {
        getClientCompanyByEmail,
        getListSubscriptionTypeAvailablePublic, purchaseSubscriptionClientPublic
    } from "../../api";
    import {
        PAYMENT_MODE,
        STRIPE_PUBLIC_KEY,
        SUBSCRIPTION_CATEGORY, TIMEZONE_DEFAULT
    } from "../../common/constants";
    import ModalContainer from "./ModalContainer";
    import PriceTable from "../common/PriceTable";
    import ConversionNote from "../common/ConversionNote";
    export default {
        name: "PurchaseSubscriptionClientModal",
        components: {ModalContainer, StripeElements, Datetime, VuePhoneNumberInput, PriceTable, ConversionNote},
        props: {
            visible: {
                type: Boolean,
                required: true
            },
            country: {
                type: String
            }
        },
        data: () => {
            return {
                subscriptionsTypeSeparator: [],
                TIMEZONE_DEFAULT: TIMEZONE_DEFAULT,
                subscriptionTypeAvailable: [],
                STRIPE_PUBLIC_KEY: STRIPE_PUBLIC_KEY,
                creditCardErrorMessage: "",
                step: 1,
                loading: false,
                client_secret: "",
                errorMessage: "",
                clientExist: false,
                clientChecked: false,
                creditCardCheckout: false,
                price: "0.00",
                price_currency: "",
                newSubscription: {
                    clientDetail: {
                        first_name: "",
                        last_name: "",
                        email: "",
                        phone_number: "",
                        phone_number_international: ""
                    },
                    subscription_type: null,
                    start_date: null,
                    payment_mode: PAYMENT_MODE.CREDIT_CARD
                },
                clientCountry: null,
                translations: {}
            }
        },
        mounted() {
            let date = new Date();
            this.newSubscription.start_date = date.toISOString();
            moveUpDatetimePopup()
        },
        computed: {
            country_phone() {
              if (this.clientCountry) {
                  return this.clientCountry
              }
              return this.country;
            },
            creditCardPaymentMode(){
                return PAYMENT_MODE.CREDIT_CARD
            },
            creditCardPaymentModeName(){
                return Utils.getStringPaymentMode(PAYMENT_MODE.CREDIT_CARD)
            },
            isSelectedNormal() {
                if (this.newSubscription.subscription_type) {
                    if (this.newSubscription.subscription_type.category === SUBSCRIPTION_CATEGORY.NORMAL) {
                        return true
                    }
                }
                return false;
            }
        },
        methods: {
            saveSubscriptionsWithSeparator(subscriptionsType) {
                let subscriptionsTypeWithSeparators = [];
                for (let i = 0; i < subscriptionsType.length; i++) {
                    if (i === 0) {
                        subscriptionsTypeWithSeparators.push({ separator: true, separator_name: Utils.getStringSubscriptionCategory(subscriptionsType[i].category).toUpperCase()});
                    } else if (subscriptionsType[i].category !== subscriptionsType[i-1].category) {
                        subscriptionsTypeWithSeparators.push({ separator: true, separator_name: Utils.getStringSubscriptionCategory(subscriptionsType[i].category).toUpperCase()});
                    }
                    subscriptionsTypeWithSeparators.push(subscriptionsType[i])

                }
                this.subscriptionsTypeSeparator = subscriptionsTypeWithSeparators;
            },
            getGrossPriceOnlineWithCreditCard(price) {
                return Utils.getGrossPriceOnlineWithCreditCard(price)
            },
            async tokenCreated (token) {
                this.loading = true;
                let stripe = window.Stripe(STRIPE_PUBLIC_KEY);

                this.token = token;
                const result = await stripe.confirmCardPayment(this.client_secret, {
                    payment_method: {
                        card: {
                            token: token.id
                        },
                    }
                });


                if (result.error) {
                    if (result.error.type === "card_error") {
                        this.creditCardErrorMessage = result.error.message
                    }
                } else {

                    if (result.paymentIntent.status === "succeeded") {
                        this.step = 4
                    }

                }

                this.loading = false;
            },
            checkClientExist() {
                if (!this.emailFieldIsValid()) {
                    return
                }
                this.getClientCompanyByEmail(this.newSubscription.clientDetail.email)
            },
            async getClientCompanyByEmail(email) {
                this.clientCountry = null;
                this.clientChecked = true;
                this.loading = true;
                try {
                    let response = await getClientCompanyByEmail(this.$route.params.company_username,
                        email);
                    const phoneNumber = parsePhoneNumber(response.phone_number);
                    this.clientCountry = phoneNumber.country;

                    this.newSubscription.clientDetail = response;
                    this.loading = false;
                    this.step = 3;
                    this.clientExist = true;

                } catch (e) {
                    this.step = 3;
                    console.log(e);
                    this.loading = false;
                }
            },
            async confirmCreditCardMethod() {
                if (!this.fieldsIsValid()) {
                    return false
                }
                this.loading = true;

                try {
                    let response = await purchaseSubscriptionClientPublic(
                        this.$route.params.company_username,
                        this.newSubscription.clientDetail.email,
                        this.newSubscription.clientDetail.first_name,
                        this.newSubscription.clientDetail.last_name,
                        this.newSubscription.clientDetail.phone_number_international,
                        this.newSubscription.subscription_type.id,
                        this.newSubscription.start_date,
                        this.newSubscription.payment_mode,
                        i18n.locale);
                    this.loading = false;
                    this.client_secret = response.payment_client_secret;
                    this.price = response.price_amount;
                    this.price_currency = response.price_currency;
                    this.creditCardCheckout = true;
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                }
            },
            async confirmPayClick(){
                this.$refs.elementsRef.submit();

            },
            emailFieldIsValid() {
                this.errorMessage = ""
                let regex = /\S+@\S+\.\S+/;

                if (!this.newSubscription.clientDetail.email || !regex.test(this.newSubscription.clientDetail.email)) {
                    this.errorMessage = i18n.t('error.email_not_valid');
                    return false
                }
                return true
            },
            fieldsIsValid() {
                this.errorMessage = ""
                if (!this.emailFieldIsValid()) {
                    return false
                }
                if (!this.newSubscription.clientDetail.first_name) {
                    this.errorMessage = i18n.t('error.first_name_not_valid');
                    return false
                }

                if (!this.newSubscription.clientDetail.last_name) {
                    this.errorMessage = i18n.t('error.last_name_not_valid');
                    return false
                }

                if (!this.newSubscription.clientDetail.phone_number_international) {
                    this.errorMessage = i18n.t('error.phone_not_valid');
                    return false
                }

                return true
            },
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency)
            },
            updatePhoneNumber(result) {
                this.newSubscription.clientDetail.phone_number_international = result.formatInternational;
            }

        },
        watch: {
            async visible(newVal) {
                if (newVal) {
                    this.loading = true;
                    try {
                        let subscriptionResponse = await getListSubscriptionTypeAvailablePublic(this.$route.params.company_username);
                        this.saveSubscriptionsWithSeparator(subscriptionResponse);
                        this.loading = false;
                    } catch (e) {
                        console.log(e);
                        this.loading = false;
                    }
                    this.translations = Utils.getTranslationsPhoneField();
                }

            },
            subscriptionsTypeSeparator(newVal) {
                if (newVal.length > 0) {
                    this.newSubscription.subscription_type = newVal[1];
                }
            }
        }
    }
</script>

<style scoped>

</style>
